import React, { Fragment } from 'react'
import useStyles from './styles'
import { Typography } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiAccount } from '@mdi/js'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import classnames from 'clsx'

const ViewerCount = ({ children }) => {
  const classes = useStyles()
  const viewerCount = useSelector(state => state.viewers.count)
  const event = useSelector(state => state.event.event)
  const popoutMode = useSelector(state => state.window.popoutMode)
  return (
    <div
      className={classnames(classes.viewerCount, {
        [classes.popoutMode]: popoutMode
      })}
    >
      {event.live_settings.show_room_count && (
        <Fragment>
          <Icon
            path={mdiAccount}
            title="Viewer Count"
            color="white"
            size={1.5}
            style={{ marginRight: 4 }}
          />
          <Typography className={classes.viewCountTypography}>
            {viewerCount}
          </Typography>
        </Fragment>
      )}
    </div>
  )
}

export default ViewerCount



// WEBPACK FOOTER //
// ./src/components/ViewerCount/index.jsx